import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  margin-bottom: 20px;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  backdrop-filter: blur(10px);
  height: 100%;
`;

const Testimonial = ({ children }) => <Wrapper>{children}</Wrapper>;

export default Testimonial;
